

// mobile menu scripts
;(function ($) {

  "use strict";

  const mqMobile = window.matchMedia( "(max-width: 575px)" );
  const mqTablet = window.matchMedia( "(min-width: 576px) and (max-width: 1199px)" );
  var offsetCompactHeader = 25;
  if (mqTablet.matches) {
    offsetCompactHeader = 25;
  }

  var offsetBgHeader = 250;
  if (mqTablet.matches) {
    offsetBgHeader = 50;
  }

  // Hide Header on on scroll down
  var $header = $('#header');
  let lastScroll = 0;
  window.addEventListener("scroll", () => {
    const currentScroll = window.pageYOffset;
    if (currentScroll <= 0) {
      $header.addClass('header--down');
      return;
    }
  
    if (currentScroll > lastScroll && !$header.hasClass('header--up')) {
      // down
      $header.removeClass('header--down');
      $header.addClass('header--up');
      // lottiePlayer.play();
    } else if (currentScroll < lastScroll && $header.hasClass('header--up')) {
      // up
      // body.classList.remove(scrollDown);
      // body.classList.add(scrollUp);

      $header.removeClass('header--up');
      $header.addClass('header--down');

      // lottiePlayer.stop();
    }
    lastScroll = currentScroll;
  });

    // burger
    $('.nav__toggle').on('click', function(e){
      e.preventDefault();
      $('.nav__toggle').toggleClass('is-active');
      $('body').toggleClass('menu-active');
    });

    $('.nav__item, .menu-item').on('click', function(e) {
      $('.nav__toggle').removeClass('is-active');
      $('body').removeClass('menu-active');
    });

    // var waypointResizeMenu = new Waypoint({
    //   element: document.getElementsByTagName('body'),
    //   handler: function(direction) {
    //     if (direction == 'up') {
    //       $header.removeClass('header--compact');
    //     }
    //     else {
    //       $header.addClass('header--compact');
    //     }
    //   },
    //   offset: -offsetCompactHeader
    // });

    // var waypointBgMenu = new Waypoint({
    //   element: document.getElementsByTagName('body'),
    //   handler: function(direction) {
    //     if (direction == 'up') {
    //       $header.removeClass('header--bg');
    //     }
    //     else {
    //       $header.addClass('header--bg');
    //     }
    //   },
    //   offset: -offsetBgHeader
    // });

    $('.header__overlay').on('click', function(e) {
      $('.nav__toggle').removeClass('is-active');
      $('body').removeClass('menu-active');
      $('body').removeClass('filter-active');
    });

    var waypoints = $('.enableHeaderBg').waypoint(function(direction) {
      if (direction == 'up') {
        $header.removeClass('header--bg');
      }
      else {
        $header.addClass('header--bg');
      }
    }, {
      offset: '0%'
    });

})(jQuery);
